import { GoalManagementAction } from '../types/GoalManagementAction';
import { GoalDescriptionBody } from '../types/GoalDescriptionBody';
import _ from 'lodash';
import {
    MasterChapter,
    MasterClass,
    MasterConcept,
    MasterSubSubject,
    MasterSubject
} from '../types/GoalManagementMasterBody'
import { courses } from '../../tag-mangement/__mocks__/tagsResponse';
import CourseSyllabusBody from '../types/CourseSyllabusBody';

interface InitialState {
    list: GoalDescriptionBody[],
    subjectList: MasterSubject[],
    subSubjectList: MasterSubSubject[],
    chapterList: MasterChapter[],
    conceptList: MasterConcept[],
    classList: MasterClass[],
    courseData:CourseSyllabusBody[],
    showAddContent: boolean;
}

const initialState: InitialState = {
    list: [],
    subjectList: [],
    subSubjectList: [],
    chapterList: [],
    conceptList: [],
    classList: [],
    courseData:[],
    showAddContent: false
}

const goalManagementReducers = (state = initialState, action: GoalManagementAction) => {
    switch (action.type) {
        case 'GOAL_MANAGEMENT_LIST_SUCCESS': {
            return { ...state, list: action.data };
        }
        case 'GOAL_MANAGEMENT_MASTER_SUBJECTS':{
            return { ...state, subjectList: action.data };
        }
        case 'GOAL_MANAGEMENT_MASTER_SUBSUBJECTS':{
            return { ...state, subSubjectList: action.data };
        }
        case 'GOAL_MANAGEMENT_MASTER_CHAPTERS':{
            return { ...state, chapterList: action.data };
        }
        case 'GOAL_MANAGEMENT_MASTER_CONCEPTS':{
            return { ...state, conceptList: action.data };
        }
        case 'GOAL_MANAGEMENT_MASTER_CLASS':{
            return { ...state, classList: action.data };
        }
        case 'GOAL_MANAGEMENT_COURSE_DATA':{
            return { ...state, courseData: action.data };
        }
        case 'GOAL_MANAGEMENT_COURSE_DATA_UPDATE':{
            let courseData = _.cloneDeep(state.courseData)
            courseData = courseData.map((cd:CourseSyllabusBody)=>{
                if(cd._id == action.data._id){
                    return action.data;
                }else{
                    return cd;
                }
            })
            return { ...state, courseData: courseData };
        }
        case 'GOAL_MANAGEMENT_SHOW_ADD_CONTENT':{
            return { ...state, showAddContent: action.data };
        }
        default: {
            return state;
        }
    }
}

export default goalManagementReducers;